import React from "react";

function Radio({ title }) {
  return (
    <>
      <div className="checkbox">
        <input type="radio" name="cb" id="cb1" />
        <label htmlFor="cb1">{title}</label>
      </div>
    </>
  );
}

export default Radio;
